import viFetchAdapter from '../viFetchAdapter';
import qs from 'qs';

export const commonQuery = {
  includeAgentInfo: true,
  includeClientInfo: true,
  includeExpired: true,
  made: 2,
  suspended: 2,
};

function clearQuery(obj: Object) {
  const cleanQuery = JSON.parse(JSON.stringify(obj));
  Object.keys(obj).forEach((key) => {
    if (cleanQuery[key] === '') {
      delete cleanQuery[key];
    }
  });
  return cleanQuery;
}

export async function loadBuildings(query: Object) {
  const cleanQuery = clearQuery(query);
  const { data } = await viFetchAdapter.get(`pagewidget/findcondition?${qs.stringify({
    ...commonQuery,
    ...cleanQuery,
  })}`);
  return data;
}


// WEBPACK FOOTER //
// ./src/libs/buildings.js